/**
 * @description https://medium.com/@Snowflakes91/angularjs-and-recursive-directives-32657fbaa543
 */
;(function () {
  'use strict'

  angular
    .module('contrast.ui')
    .factory('recursiveDirectiveHelper', recursiveDirectiveHelperFactory)

  function recursiveDirectiveHelperFactory($compile) {
    'ngInject'

    var service = {
      compile: compile
    }

    return service

    function compile(element, link) {
      var contents = element.contents().remove()
      var compiledContents
      return {
        pre: link && link.pre ? link.pre : null,
        /**
         * Compiles and re-adds the contents
         */
        post: function (scope, element) {
          // Compile the contents
          if (!compiledContents) {
            compiledContents = $compile(contents)
          }
          // Re-add the compiled contents to the element
          compiledContents(scope, function (clone) {
            element.append(clone)
          })

          // Call the post-linking function, if any
          if (link && link.post) {
            link.post.apply(null, arguments)
          }
        }
      }
    }
  }
})()
